import { gql } from '@apollo/client';
const GET_CURRENT_TENANT_STATUSES = gql `
  query GetCurrentTenantStatuses($first: Int = 50, $after: String = "") {
    me {
      id
      currentTenant {
        id
        statuses(first: $first, after: $after) {
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              namePL
              nameEN
              color
              canBeUpdated
              canBeRemoved
            }
          }
        }
      }
    }
  }
`;
export default GET_CURRENT_TENANT_STATUSES;
